/**
 * @file
 * A JavaScript file containing the carousel functionality
 */

(function (Drupal, $) {
  Drupal.behaviors.carousel = {
    attach: function (context) {
      $(document).ready(function () {
        $(".tiny-slider", context)
          .once("carousel-processed")
          .addClass("carousel-processed")
          .each(function () {
            var options = $(this).data("carousel");
            var itemSizeSmall = {
              0: { edgePadding: 0, gutter: 10, items: 1 },
              450: { edgePadding: 15, gutter: 16 },
              900: { edgePadding: 23, gutter: 24, items: 2 },
              1150: { items: 3 },
            };
            var itemSizeBig = {
              0: { gutter: 10, items: 1 },
              600: { gutter: 16, items: 2 },
              900: { items: 3 },
              1250: { items: 4 },
            };
            var itemSizeSideInfo = {
              0: { items: 1 },
              1000: { items: 2 },
              1350: { items: 3 },
            };

            var itemSizeNone = {
              0: {},
            };

            var itemSize = itemSizeSmall;
            if (options.itemSize == "none") {
              itemSize = itemSizeNone;
            } else if (options.itemSize == "big") {
              itemSize = itemSizeBig;
            } else if (options.itemSize == "side-info") {
              itemSize = itemSizeSideInfo;
            }

            var slider = tns({
              nav: options.nav,
              loop: options.loop,
              controlsText: options.controlsText ? options.controlsText : ["&larr;","&rarr;"],
              container: this,
              autoWidth: options.autoWidth,
              autoplay: false,
              mouseDrag: true,
              gutter: options.gutter,
              edgePadding: 0,
              controls: options.controls ? options.controls : true,
              slideBy: options.slideBy,
              arrowKeys: false,
              items: options.items,
              responsive: itemSize,
            });

            if ($(this).hasClass("has-range-slider")) {
              var range = $(".carousel__range");
              range.on("input", function (e) {
                e.preventDefault();
                slider.goTo(Math.round(range.val()));
              });
            }

            if (
              $(this).closest(".carousel").hasClass("carousel--anchor-link")
            ) {
              $(".carousel-anchor-link__item").first().addClass("isActive");
              $(document).on("click", ".carousel-anchor-link__item", function (
                e
              ) {
                e.preventDefault();
                var $this = $(this);
                $this.addClass("isActive").siblings().removeClass("isActive");
                slider.goTo($this.index());
                var target = $this.attr("href");
                target = target.substring(1, target.length);
                $(window).scrollTop($("#" + target).offset().top);
              });
            }

            $(".anchor-link-menu__select").on("change", function () {
              var target = $("option:selected", this)[0].value;
              $(window).scrollTop($(target).offset().top - 30);
            });
          });

        //custom JS for copy image carousel
        var slideItem = $(".carousel--copy-image .slide-item");
        function adjustCarouselItems() {
          if (slideItem.length && $(window).width() >= 760) {
            slideItem.height("initial");
            slideItem.height(slideItem.parent().height());
          } else {
            slideItem.height("auto");
          }
        }
        adjustCarouselItems();
      });
    },
  };
})(Drupal, jQuery);
